<template>
  <div>
    <modal
      class="new-modal-dropdown"
      :name="modal_name"
      transition="nice-modal-fade"
      :delay="100"
      height="auto"
      :min-height="200"
      :min-width="400"
      :pivot-y="0.5"
      :adaptive="true"
      :scrollable="false"
      style="pointer-events:inherit !important" 
      v-bind:click-to-close="false"
    >
      <div style="width: 100%; padding: 50px">
        <span style="color: #000; font-weight: 600; font-size: 20px;">Time Zone</span>
        <multiselect
          v-validate="'required'"
          class="diginew-multiselect"
          placeholder="Select Time Zone"
          :clearable="false"
          index="value"
          :filterable="true"
          :options="timezone"
          v-model="timeZoneValue"
          name="time_zone"
          label="label"
          style="width: 100%; margin-top: 14px; background: #efefef !important;"
        ></multiselect>
        <div class="d-flex justify-content-center align-item-center mt-10">
          <button
            type="button"
            class="btn btn-new-primary btn-smm mx-2"
            style="box-shadow: none !important;"
            @click="removeTimeZone"
          >REMOVE TIME ZONE</button>
          <button
            type="button"
            class="btn btn-danger btn-smm mx-2"
            style="box-shadow: none !important;"
            @click="hideTimeZone"
          >CANCEL</button>
          <button
            type="button"
            class="btn btn-new-green btn-smm mx-2"
            style="box-shadow: none !important;"
            @click="saveNewTimeZone"
          >OK</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import timezone from "./json/timezone.json";
import { EventBus } from "./eventBus/nav-bar-event.js";
export default {
  data() {
    return {
      timezone: timezone,
      timeZoneValue: {},
    };
  },
  props: ["modal_name", "time_zone"],
  mounted() {
    this.timezone.forEach(x => {
      if (x.value === this.time_zone) {
        this.timeZoneValue = x;
      };
    });
  },
  methods: {
    hideTimeZone() {
        this.$modal.hide(this.modal_name);
        this.$emit("hidetimezone");
    },
    saveNewTimeZone() {
        this.$modal.hide(this.modal_name);
        this.$emit("savenewtimezone", this.timeZoneValue);
    },
    removeTimeZone() {
        this.$modal.hide(this.modal_name);
        this.$emit("removetimezone");
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/TimeZoneModal.vue